import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.25 2a2.25 2.25 0 0 1 2.25 2.25v5.5H18v-5.5a.75.75 0 0 0-.75-.75h-5.002l.003 3.999a2.25 2.25 0 0 1-2.23 2.251H9.75v.001H6v9.999c0 .414.336.75.75.75h3V22h-3a2.25 2.25 0 0 1-2.25-2.25V9.621c0-.596.237-1.169.658-1.59l5.368-5.372c.422-.422.995-.659 1.592-.659zm1.826 9.924a2.25 2.25 0 0 1 2.25 2.25v5.424c0 .954-.799 1.728-1.784 1.728h-5.833c-.985 0-1.785-.774-1.785-1.728v-5.424a2.25 2.25 0 0 1 2.25-2.25zm-4.902 1.5a.75.75 0 0 0-.75.75v3.81l.765-.39a1.84 1.84 0 0 1 1.721.033l1.058.59c.717.4 1.625.27 2.191-.315l.667-.69v-3.038a.75.75 0 0 0-.75-.75zm1.124 1.071a.8.8 0 1 1 0 1.6h-.005a.8.8 0 0 1 0-1.6zm-8.24-6.244h2.943a.75.75 0 0 0 .75-.751l-.003-2.941z"
    }, null, -1)
  ]))]))
}
export default { render: render }